export default __webpack_public_path__ + "static/media/gallery_10.3360b507.jpg";